import React from 'react'
import {
  NutritionalBenefitsRoot,
  Header,
  NutritionalBenefitsContainer,
  ButtonWrapper,
} from './NutritionalBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import food from '../../../../../public/assets/raw-benefits/raw-dog-food-ingredients-bowl.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'

export const NutritionalBenefits: React.FC = () => {
  const { t } = useTranslation()
  const carbContentLink = 'https://www.dogfoodadvisor.com/choosing-dog-food/dog-food-carbohydrate-content/'
  const NutritionCopy = () => (
    <Stack gap='3' direction='column'>
      <Text size='headline' weight='bold'>{t('raw-benefits:nutritional-benefits.question')}</Text>
      <Text>
        <Trans i18nKey='raw-benefits:nutritional-benefits.answer.0' components={{ Link: <Link href={carbContentLink} />}} /></Text>
      <Text>{t('raw-benefits:nutritional-benefits.answer.1')}</Text>
      <Text>{t('raw-benefits:nutritional-benefits.answer.2')}</Text>
      <Text>{t('raw-benefits:nutritional-benefits.answer.3')}</Text>
    </Stack>
  )
  return (
    <NutritionalBenefitsRoot>
      <NutritionalBenefitsContainer>
        <Header>{t('raw-benefits:nutritional-benefits.title')}</Header>
        <ImageWithText
          copyColumn={<NutritionCopy />}
          imageSrc={food}
          imageAlt="raw-benefits:nutritional-benefits.image-alt"
          imageSide="right"
        ></ImageWithText>
        <ButtonWrapper>
          <Link href="/meal-plan" passHref>
            <Button as="a" className="cta">{t('raw-benefits:hero.primary-cta')}</Button>
          </Link>
        </ButtonWrapper>
      </NutritionalBenefitsContainer>
    </NutritionalBenefitsRoot>
  )
}

NutritionalBenefits.displayName = 'NutritionalBenefits'
